import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const messages = {
    fa: {
        'Dashboard': 'داشبورد',
        'control panel': 'پنل مدیریت',
        'Customer managements': 'مدیریت مشتریان',
        'Customer club': 'باشگاه مشتریان',
        'Gifts and discounts': 'هدایا و تخفیفات',
        'Score( points) managements': 'مدیریت امتیازها',
        'Customer gifts (points)': 'هدایای امتیازی مشتریان',
        'Category managements': 'مدیریت برچسب ها',
        'Group managements': 'مدیریت گروه ها',
        'Service managements': 'مدیریت خدمات',
        'Product Managements': 'مدیریت کالا ها',
        'Ready to operate': ' آماده به فعالیت',
        'Personnel Managements': 'مدیریت پرسنل',
        'Manage payments/credit enhancement': 'مدیریت پرداخت ها / افزایش اعتبار',
        'Customer Receipts': 'درخواست های مشتری',
        'Calendar (TIMETABLE)': 'تقویم کاری',
        'Increase credit (payment)':'(افزایش اعتبار (پرداختی',
        'Personal work calendar': 'تقویم کاری شخصی',
        'Buy gifts and points': 'خرید هدیه و امتیاز',
        'Buy gifts':'خرید هدیه',
        'Calendar': 'تقویم ',
        'Back': 'بازگشت',
        'Type of service': 'نوع خدمت',
        'product type': 'نوع کالا',
        'SMS Automation': 'اتوماسیون پیامک',
        'SMS': 'پیامک',
        'Submitted text': 'متن ارسالی',

        'Financial managements': 'مدیریت مالی',
        'Cost center': 'مرکز هزینه',
        'Income center': 'مرکز درآمد',
        'Accounts': 'حساب ها',
        'Title': '	عنوان',
        'Reports': 'گزارشات',
        'Top services': '	خدمات برتر',
        'Top customer report': 'گزارش مشتریان برتر',
        'Top beauticians report': 'گزارش ارایشگران برتر',
        'Sales trend chart': 'نمودار فروش',
        'Cost and Income report': 'گزارش درامد و هزینه',
        'Settings': 'تنظیمات',
        'User settings': 'تنظیمات کاربران',
        'Role settings': 'تنظیمات نق ش ها',
        'Search': 'جستجو',
        'Ready': 'آماده به فعالیت',
        'Add customer': 'مشتری جدید',
        'New': 'مشتری جدید',
        'Reservation': ' ثبت نوبت',
        'No message': 'پیامی وجود ندارد',
        'any things': 'وجود ندارد',
        'Customer code': ' کد مشتری',
        'Name': 'نام ',
        'surname': 'نام خانوادگی',
        'Mobile/ phone number': 'موبایل/ تلفن',
        'Mobile': 'موبایل',
        'phone': 'تلفن',
        'Registration date': 'تاریخ ثبت ',
        'Score': 'امتیاز',
        'profile': 'پروفایل',
        'File': 'فایل',
        'SMS,E-mail': 'اس ام اس ایمیل',
        'Edit': 'ویرایش',
        'Delete': 'حذف',
        'Reserve': 'رزرو نوبت',
        'User (score) point': 'امتیاز کاربر',
        'Send message': 'ارسال پیام',
        'Send': 'ارسال',
        'next': 'بعدی',
        'Town': 'شهر',
        'Groups': 'گروه ها',
        'Add': 'افزودن',
        'Code': 'کد',
        'National Code': 'کد ملی',
        'Number of use': 'تعداد استفاده',
        'Number of sale': 'تعداد فروش',
        'Number of serve': 'تعداد ارائه خدمت',
        'Average of serve': 'کارکرد میانگین',
        'Gift type': 'نوع هدیه',
        'Gift': 'هدیه',
        'type': 'نوع',
        'Gift amount': 'مقدار هدیه',
        'Start date': 'تاریخ شروع',
        'Start': 'شروع',
        'End': 'پایان',
        'End date': 'تاریخ پایان',
        'Services': 'خدمات',
        'Service Name': 'نام سرویس',
        'Products': 'کالا ها',
        'Product Name': 'نام کالا',
        'Service': 'خدمت',
        'product': 'کالا',
        'Image': 'تصویر',
        'list': ' لیست',
        'Assortment management': 'مدیریت دسته‌بندی',
        'Assortment': 'دسته بندی',
        'Minimum time': 'حداقل زمان',
        'Maximum time': 'حداکثر زمان',
        'Excel Output List': 'خروجی Excel لیست دریافتی ها',
        'Excel Output Service List': 'خروجی Excel لیست خدمات',
        'Excel Output Products List': 'خروجی Excel لیست کالا ها',
        'Excel Output Personel List': 'خروجی Excel لیست پرسنل',
        'Excel Output payments List': 'خروجی Excel لیست پرداختی ها',
        'Excel Output Orders List': 'خروجی Excel لیست سفارشات',
        'Excel Output Account List': 'خروجی Excel لیست حساب ها',
        'Initial amount': 'مقدار اولیه',
        'Residual amount': 'مقدار باقی مانده',
        'amount': 'مقدار ',
        'Height': 'قد',
        'unit': 'واحد',
        'Price(toman)': 'قیمت',
        'status': 'وضعیت',
        'Active': 'فعال',
        'Inactive': ' غیرفعال',
        'Number': 'عدد',
        'g': 'گرم',
        'Kg': 'کیلوگرم',
        'Liter': 'لیتر',
        'packet': 'بسته',
        'Timetable': 'زمان بندی',
        'Description of service': 'شرح خدمت',
        'Beautician service': 'خدمات ارایشگر',
        'Beautician timetable': 'زمان بندی ارایشگر',
        'password': 'کلمه عبور',
        'Show receipt': 'نمایش رسید',
        'Receipt Request': 'فاکتور',
        'receipt': 'رسید',
        'Date': 'تاریخ',
        'Select the date': 'تاریخ را انتخاب کنید',
        'Discount': 'تخفیف',
        'Final price': 'قیمت نهایی',
        'Total Amount': 'مبلغ کل',
        'Best-selling products': 'کالا ها پرفروش	',
        'Choose date': 'انتخاب تاریخ',
        'Sent SMS list': '  لیست اس ام اس های ارسال شده',
        'List of sent sms': 'لیست sms های ارسال شده',
        'Discount Percentage as': 'درصد تخفیف با عنوان',
        'Subtracted from total amount': 'از مبلغ کل کسر گردید',
        'Credit discount with title': 'تخفیف  با عنوان ',
        'Context': 'متن',
        'Group sending': 'ارسال گروهی	',
        'Include these tags': 'شامل این تگ (برچسب) ها باشد',
        'Do not Include these tags': 'شامل این تگ (برچسب) ها نباشد',
        'tags':'تگ ها',
        'Including these tags': 'شامل این برچسب ها باشد',
        'Include these users': 'شامل این کاربران باشد',
        'Do not include these users': 'شامل این کاربران نباشد',
        'Send via': ' ارسال از طریق',
        'e-mail': 'ایمیل',
        'Notification': 'نوتیف',
        'done': 'ثبت',
        'Done':'انجام شد',
        'Mobile number': 'شماره موبایل',
        'phone/mobail': 'موبایل / تلفن',
        'Hair': 'مو',
        'From': ' از تاریخ',
        'to': 'تا تاریخ',
        'Status code': 'کد وضعیت',
        'SMS status': 'حالت اس ام اس',
        'Sending': 'در صف ارسال',
        'Sent to telecommunication': 'ارسال به مخابرات',
        'Account': 'حساب',
        'Receiver': 'دریافت کننده',
        'Entry date': 'تاریخ ثبت',
        'Due date': 'تاریخ سررسید',
        'Cost type': 'نوع هزینه',
        'Cost': 'نوع',
        'Amount': 'مبلغ',
        'Paid': 'پرداخت شده',
        'Payment in progress': 'در جریان پرداخت',
        'revoked': 'ابطال شده',
        'Buying Equipment': 'خرید تجهیزات',
        'Buying goods': 'خرید کالا',
        'Good': 'کالا',
        'Buy':'خرید',
        'Transportation cost': 'هزینه ایاب و ذهاب',
        'Forwarding(transportation) cost': 'هزینه حمل و نقل',
        'Water, electricity, telephone bills': 'هزینه آب و برق و تلفن',
        'Salary cost': 'هزینه حقوق',
        'Payable documents': 'اسناد پرداختنی',
        'Renting cost': 'هزینه اجاره',
        'Fund/?': 'برداشت/تنخواه',
        'Other cots': 'سایر هزینه ها',
        'cots': 'هزینه ها',
        'Document number': 'شماره سند',
        'Order number': 'شماره سفارش',
        'Payer': 'پرداخت کننده',
        'Description': 'شرح',
        'Points / Degree of importance': 'امتیاز/درجه اهمیت',
        'Bank acceptance type': ' نوع دریافتی',
        'Payment status': 'وضعیت پرداختی',
        'Receive from ': 'دریافت از ',
        'Service and product order': 'شفارش کالا و خدمات',
        'Beautician bank  for rent': 'دریافتی (اجاره) از ',
        'Other  bank acceptance(recived) documents': 'سایر اسناد دریافتی',
        'Account number': 'شماره حساب',
        'Sheba number': 'شماره شبا',
        'Debtor': 'بدهکار',
        'Creditor': 'بستانکار',
        'Account balance': 'مانده حساب',
        'Agent bank': ' بانک عامل	',
        'Refresh (update information)': 'بروز رسانی اطلاعات',
        'More information': 'اطلاعات بیشتر',
        'type of Document': 'نوع سند',
        'Customers': 'مشتریان',
        'Customer': 'مشتری',
        'Best': 'برتر',
        'Income trend': 'روند درآمدی',
        'Update': 'بروزرسانی',
        'Update service': 'بروزرسانی خدمات',
        'cost and income Total report': 'گزارش کلی درآمد و هزینه',
        'Number of visits': 'تعداد مراجعه',
        'Total revenue from booking services':'جمع درآمد حاصل از رزرو خدمات',
        's': 'ان',
        'Income from reserving services': 'درآمد حاصل از رزرو خدمات',
        'Add categories': 'افزودن دسته بندی',
        'Add product category':'افزودن دسته بندی کالا',
        'categories': 'دسته بندی',
        'Income from selling products': 'درآمد حاصل از فروش کالا',
        'Income from products': 'درآمد حاصل از کالا',
        'Total income': 'مجموع درآمد',
        'Total cost': 'مجموع هزینه',
        'profit': 'سود',
        'Total Income from reserving services': 'جمع درآمد حاصل از خدمات',
        'Total Income from selling products': 'جمع درآمد حاصل از کالا ها',
        'Total costs': 'جمع هزینه ها',
        'costs': 'هزینه ها',
        'QTY': 'ردیف',
        'Role managements': 'مدیریت نقش ها',
        'User role': 'نقش کاربر',
        'role': 'نقش',
        'User': 'کاربر',
        'User managements': 'مدیریت کاربران',
        'Role accesses': 'دسترسی نقش ها',
        'accesses': 'دسترسی',
        'Choosing Date and services': 'انتخاب تاریخ و خدمات',
        'Choosing beautician and time': 'انتخاب آرایشگر و زمان',
        'View receipt': 'مشاهده فاکتور',
        'Final approval': 'تایید نهایی',
        'Confirmation': 'تایید',
        'Canceled': 'لغو شده',
        'Payment approved': 'پرداخت تایید شده',
        'Order done': 'سفارش انجام شده',

        'Order': ' سفارش',
        'Orders': 'سفارشات',
        'Ordering goods and services': ' سفارش کالا و خدمات',
        'Visit date': 'تاریخ حضور',
        'Visit time': 'زمان حضور',
        'End time': 'زمان پایان',
        'services': 'خدمات',
        'Serial': 'سریال',
        'Return to the list': 'بازگشت به لیست',
        'Return to product list':'بازگشت به لیست کالا ها',
        'Return to profile':'بازگشت به پروفایل',
        'beautician': 'ارایشگر',
        'Total price': 'قیمت کل',
        'Default price': 'قیمت پیش فرض',
        'survey': 'نظرسنجی',
        'Print receipt': 'پرینت فیش',
        'print': 'پرینت',
        'Discount or credit code entry': 'وارد کردن کد تخفیف یا اعتبار',
        'Apply a discount code': 'اعمال کد تخفیف',
        'Payable amount': 'مبلغ قابل پرداخت ',
        'Back was shown': 'برگشت به نمایش رسید',
        'Payment receipt successfully deducted from customer credit': ' تأیید پرداخت انجام شده است',
        'pay': 'پرداخت',
        'pays': 'پرداخت ها',
        'Cancel order': 'لغو سند',
        'Cancel': 'لغو',
        'Arrange next visit': 'تنظیم یادآوری بعدی',
        'Description and notes': 'توضیحات و یادداشت ها',
        'Status description': 'شرح وضعیت',
        'Name and Description': 'نام و توضیحات',
        'Add Attachment/note': 'افزودن پیوست/یادداشت',
        'Add interest':'افزودن علاقه مندی',
        'Attachment/note': 'پیوست/یادداشت',
        'Download': 'دانلود',
        'Reserved times': 'زمان های رزرو شده',
        'Initial reservation and choosing time': ' ثبت اولیه و تعیین وقت',
        'Instant reservation': 'ثبت سریع',
        'Booking receipt registration': 'ثبت رسید رزرو',
        'Between time': 'بین وقت',
        'Choose time': 'انتخاب ساعت',
        'Choose': 'انتخاب',
        'time': 'ساعت',
        'start time': 'زمان شروع',
        'End Time': 'زمان پایان',
        'Survey': 'نظرسنجی',
        'from': 'از ساعت',
        'Customer profile': 'پروفایل مشتری',
        'Reprogramming': 'برنامه ریزی مجدد',
        'Customer reservations and ?': 'رزرو ها و پیگیری های مشتری',
        'Notes and attachments': 'یادداشت ها و پیوست ها',
        'Add note/attachment': 'افزودن یادداشت/پیوست',
        'the attachment': 'پیوست',
        'Total customer orders': 'جمع سفارشات مشتری',
        'Total customer payments': 'جمع پرداختی های مشتری',
        'Sum of payments':'جمع پرداخت ها',
        'Residual payable amount': 'مبلغ باقی مانده قابل پرداخت',
        'Event managements': 'مدیریت مناسب ها',
        'Events': 'مناسبت ها',
        'Way of introduction': 'طریقه آشنایی',
        'Page Reagent': 'پیج معرف',
        'Referral site': 'سایت معرف',
        'Introducer': 'معرف',
        'Advertised site': 'سایت تبلیغ شده',
        'Advertised page': 'پیج تبلیغ شده',
        'Field of study': 'رشته تحصیلی',
        'Field': 'رشته',
        'gender': 'جنسیت',
        'Field of work': 'فیلد کاری',
        'Date of birth': 'تولد',
        'profession': 'تخصص',
        'age': 'سن',
        'Done and update information ': 'ثبت و بروزرسانی',
        'toman': 'تومان',
        'Booking services': 'رزرو  خدمات',
        'Sell Products': 'فروش کالا ها',
        'Sell Product': 'فروش کالا',
        'Best-selling services': 'خدمات پرفروش',
        'Reservations and Tracking': 'رزرو ها و پیگیری ها',
        'Record reminder': 'ثبت یادآوری',
        'reminder': ' یادآوری',
        'Close': 'بستن',
        'Show all': 'نمایش همه',
        'Exit': 'خروج',
        'Time booking': 'رزرو وقت',
        'booking': 'رزرو',
        'Submit request': 'ثبت درخواست',
        'Public': 'همگانی',
        'target': 'تارگت',
        'min': 'دقیقه',
        'until the':'تا',
        'Unknown': 'نا مشخص',
        'Sum of functions':'جمع کارکرد ها',
        'it is registered': 'ثبت شده است',
        'and time': 'و زمان',
        'reservation date': 'تاریخ رزرو',
        'Username': 'نام کاربری',
        'Reservation plan': 'برنامه جهت رزرو',
        'Password': 'پسورد',
        'Login': 'ورود به نرم افزار',
        'Remaining to pay': 'باقیمانده جهت پرداخت',
        'Extra customer credit': 'اعتبار اضافی مشتری',
        'Set next reminder': 'تنظیم یادآوری بعدی ',
        'Remind date of attendance':'یادآوری تاریخ حضور در ',
        'Final confirmation of service (receiving points)': 'تأیید و ثبت دائمی سند',
        'Balance payable': 'جمع  مانده پرداخت',
        'Total payments for receipts': 'جمع پرداختی ها برای رسید',
        'The total amount reached': 'جمع  مبلغ کل رسید',
        'The remaining amount is due for payment': 'مبلع باقیمانده رسید جهت پرداخت',
        'Confirmation of payment of outstanding balance': 'تایید پرداخت مبلغ باقیمانده رسید',
        'Next for': 'بعدی برای',
        'Initial registration and appointment': 'ثبت اولیه و تعیین وقت',
        'Nails': 'ناخن',
        'Nail services': ' خدمات ناخن',
        'Facial Services':'خدمات صورت',
        'Rosary times': 'زمان های رزور شده',
        'Button to select the beginning time of booking and service first': 'برای انتخاب زمان ابتدای رزرو و خدمت اول دکمه',
        'Click': 'کلیک کنید',
        'Click on the button to select the next service you want': ' برای انتخاب خدمات بعدی مورد نظر به ترتیب روی دکمه',
        'Contacts': 'اطلاعات تماس',
        'Address': 'آدرس',
        'other information': 'سایر اطلاعات',
        'Attributes': 'ویژگی ها',
        'Attribute': 'ویژگی',
        'Weight': 'وزن',
        'disease background': 'سابقه بیماری',
        'Heart': 'قلبی',
        'Breathing': 'تنفسی',
        'Liver': 'کبدی',
        'Kidney': 'کلیوی',
        'Diabetes': 'دیابت',
        'Seizure': 'تشنج',
        'infectious disease': 'بیماری عفونی ',
        'Herpes simplex history': 'سابقه تبخال',
        'Tumor': 'تومور',
        'Asthma': 'اسم',
        'Thyroid': 'تیروءید',
        'Disorder': 'اختلال',
        'Hermione': 'هرمونی',
        'other': 'سایر',

        'History of medication use': 'سابقه مصرف دارو',
        'Aspirin': 'آسپرین',
        'Anticonvulsant': 'داروی ضد تشنج',
        'Arfarin': 'آرفارین',
        'Heparin': 'هپارین',
        'Minoxide': 'ماینوکسید',
        'Hormone Drug': 'داروی هورمونی',
        'Rakutan': 'راکوتان',
        'DiaphPeeling Creamragm': 'کرم لایه بردار',
        'Tanned in the last two months': 'اقدام به برنزه کردن در دوماه اخیر',
        'Yes': 'بله',
        'No': 'خیر',
        'A history of any allergy, seasonality, medication, food?': 'سابقه هرگونه حساسیت ,فصلی,دارویی,غذایی؟',
        'Surgical history': 'سابقه جراحی',
        'Type of surgery': 'نوع جراحی',
        'Surgery': 'جراحی',
        'Get pregnant right now': 'درحال حاضر باردارید',
        'Lactation': 'شیر دهی',
        'History of Botox injection': 'سابقه تزریق بوتاکس',
        'History of gel injection': 'سابقه تزریق ژل',
        'Laser history': 'سابقه انجام لیزر',
        'Registering and updating information': ' ثبت و بروزرسانی اطلاعات',
        'Add feature': 'افزودن ویژگی',
        'The amount of': 'به مبلغ',
        'Time to attend': 'زمان حضور در',
        'Phone call': 'تماس تلفن',
        'Caller phone': 'تلفن تماس گیرنده',
        'editing information': 'ویرایش اطلاعات',
        'Continues': 'ادامه',
        'A reminder of the date of attendance': 'یاداوری تاریخ حضور در',
        'Support team': 'تیم پشتیبانی',
        'An email for you': 'یک ایمیل برای شما',
        'Registered as': 'ثبت به عنوان',
        'Overall Poll': 'نظر سنجی کلی',
        'Submit comment': 'ثبت نظر',
        'Sample': 'نمونه',
        'Opinion': 'نظر',
        'About Me': 'درباره من',
        'Location': 'موقعیت',
        'Favorites': 'علاقه مندی ها',
        'Clearing':'پاکسازی',
        'Cleansing mask':'ماسک وپاکسازی',
        'Raspberry and honey mask':'ماسک تمشک و عسل',
        'It was Tibet':'ثبت شد',
        'Item saved successfully':'آیتم با موفقیت ذخیره شد',
        'Information updated successfully':'اطلاعات با موفقیت بروزرسانی شد',
        'Unable to update information':'بروزرسانی اطلاعات ممکن نیست',
        'The service is not selected correctly':'خدمات به درستی انتخاب نشده است',
        'Day selection and service completed successfully':'انتخاب روز و خدمات با موفقیت انجام شد',
        'There is no blank expert on the selected date':'در تاریخ انتخاب شده متخصص خالی وجود ندارد',
        'Selected product inventory is running out':'موجودی کالا انتخابی به اتمام رسیده است',
        'In the process of payment':'درجریان پرداخت',
        'Your access to this section is restricted':'دسترسی شما برای این بخش محدود شده است',
        'Are you sure you want to delete the item?':'از حذف آیتم مطمئن هستید؟',
        'Are you sure you want to delete the reminder?':'از حذف یادآوری مطمئن هستید؟',
        'Cannot delete item':'امکان حذف آیتم وجود ندارد',
        'Information received successfully':'اطلاعات با موفقیت دریافت شد',
        'No information':'اطلاعاتی وجود ندارد',
        'Unable to load item':'بارگذاری آیتم امکان پذیر نیست',
        'Unable to load categories':'بارگذاری دسته بندی ها امکان پذیر نیست',
        'Successfully registered':'با موفقیت ثبت شد',
        'List all gifts':'لیست تمام هدیه ها',
        'A list of gifts for you':'لیست هدایا مربوط به شما ',
        'Purchase done':'خرید انجام شد',
        'Are you sure you want to cancel the order?':'از لغو سفارش مطمئن هستید؟',
        'Cancellation successful':'لغو با موفقیت انجام شد',
        'Cannot cancel item':'امکان لغو آیتم وجود ندارد',
        'Unable to load data':'بارگذاری  دیتا امکان پذیر نیست',
        'Service updated successfully':'خدمات با موفقیت بروزرسانی شد',
        'Unable to update services':'امکان بروزرسانی خدمات وجود ندارد',
        'Request information is not available':'اطلاعات فاکتور در دسترس نیست',
        'Discount code applied successfully':'کد تخفیف با موفقیت اعمال شد',
        'The selected amount is greater than the remaining factor of the invoice':'مبلغ انتخابی بیشتر از رقم باقیمانده از فاکتور می باشد',
        'Payment confirmed successfully':'تایید پرداخت با موفقیت انجام شد',
        'Order canceled':'لغو سفارش انجام شد',
        'Are you sure you have a final order confirmation?':'از تایید نهایی سفارش مطمئن هستید؟',
        'The service was successfully approved':'انجام خدمت با موفقیت تایید شد',
        'Next reminder set successfully':'یادآوری بعدی با موفقیت تنظیم شد',
        'No information available':'اطلاعات در دسترس نیست',
        'The length of service is longer than your chosen time':'مدت انجام خدمت بیشتر از زمان انتخابی شماست',
        'Selected times are already filled':'زمان های انتخابی شده قبلا پر شده است',
        'You have time to complete the order':'زمان شما برای تکمیل سفارش به پایان رسیده است',
        'There is a time lag between your choices':'وقفه زمانی در بین انتخاب های شما وجود دارد',
        'Excel Output Report':'خروجی Excel گزارش',
        'Total proceeds from product sales':'جمع درآمد حاصل از فروش کالا',
        'Personnel Income':'درآمد پرسنل',
        'Personnel':'پرسنل',
        'The whole function':'کل کارکرد',
        'etc':'سایر موارد'
    },
    en: {
        'Dashboard': 'Dashboard',
        'control panel': 'control panel',
        'Customer managements': 'Customer managements',
        'Customer club': 'Customer club',
        'Gifts and discounts': 'Gifts and discounts',
        'Score( points) managements	': 'Score( points) managements',
        'Customer gifts (points) ': 'Customer gifts (points) ',
        'Category managements': 'Category managements',
        'Group managements': 'Group managements',
        'Top customer report': 'Top customer report',
        'Service managements': 'Service managements',
        'Product Managements': 'Product Managements',
        'Personnel Managements': 'Personnel Managements',
        'Customer Receipts': 'Customer Receipts',
        'Calendar (TIMETABLE)': 'Calendar (TIMETABLE)',
        'SMS Automation': 'SMS Automation',
        'Financial managements': 'Financial managements',
        'Cost center': 'Cost center',
        'Income center': 'Income center',
        'Accounts': 'Accounts',
        'Reports': 'Reports',
        'More information': 'More information',
        'Top customers report': 'Top customers report',
        'Top services': 'Top services',
        'Top beauticians report': 'Top beauticians report',
        'Sales trend chart': 'Sales trend chart',
        'Cost and Income report': 'Cost and Income report',
        'Settings': 'Settings',
        'User settings': 'User settings',
        'Role settings': 'Role settings',
        'Reservation': 'Reservation',
        'Search': 'Search',
        'Ready': 'Ready',
        'Add customer': 'Add customer',
        'Customer code': 'Customer code',
        'Name': 'Name ',
        'surname': 'surname',
        'Mobile/ phone number': 'Mobile/ phone number',
        'Mobile': 'Mobile',
        'phone': 'phone',
        'Registration date': 'Registration date',
        'Score': 'Score',
        'profile': 'profile	',
        'SMS, E-mail': '',
        'Information received successfully':'Information received successfully',
        'Edit': 'Edit',
        'Delete': 'Delete',
        'Reserve': 'Reserve',
        'User (score) point': 'User (score) point',
        'Customer profile': 'Customer profile',
        'Send message': 'Send message',
        'next': 'next',
        'Town': 'Town	',
        'Address': 'Address',
        'Groups': 'Groups',
        'Add': 'Add',
        'Code': 'Code',
        'Title': 'Code',
        'Number of use': 'Number of use',
        'Number of sale': 'Number of sale',
        'Number of serve': 'Number of serve',
        'Average of serve': 'Average of serve',
        'Gift type': 'Gift type',
        'Gift amount': 'Gift amount',
        'Start date': 'Start date',
        'End date': 'End date',
        'Customers': 'Customers	',
        'Services': 'Services',
        'Products': 'Products',
        'Edit/ delete': 'Edit/ delete',
        'Back': 'Back',
        'Score(point)': 'Score(point)',
        'Service': 'Service',
        'product': 'product',
        'No information':'No information',
        'Customer': 'Customer',
        'list': ' list',
        'Assortment management': 'Assortment management',
        'Assortment': 'Assortment',
        'Image': 'Image',
        'Default price': 'Image',
        'Minimum time': 'Minimum time',
        'Maximum time': 'Maximum time',
        'Initial amount': 'Initial amount',
        'Residual amount': 'Residual amount',
        'unit': 'unit',
        'Price( toman)': ' Price( toman)',
        'status': 'status',
        'Active': 'Active',
        'Inactive': ' Inactive',
        'Number': 'Number',
        'g': 'g',
        'Kg': 'Kg',
        'Liter': 'Liter',
        'packet': 'packet',
        'Timetable': 'Timetable',
        'Beautician service': 'Beautician service',
        'Beautician timetable': 'Beautician timetable',
        'password': 'password',
        'Show receipt': 'Show receipt',
        'Date': 'Date',
        'Discount': 'Discount',
        'Final price': 'Final price',
        'products': 'products	',
        'Choose date': 'Choose date',
        'Sent SMS list': ' Sent SMS list',
        'Context': 'Context',
        'Group sending': 'Group sending',
        'Including these tags': 'Including these tags',
        'Do not include these tags': 'Do not include these tags',
        'Include these users': 'Include these users',
        'Do not include these users': 'Do not include these users',
        'Send via': ' Send via',
        'e-mail': 'e-mail',
        'Notification': 'Notification',
        'SMS': 'SMS',
        'done': 'done',
        'Done':'Done',
        'Mobile number': 'Mobile number',
        'From': ' From',
        'to': 'to',
        'Status code': 'Status code',
        'SMS status': 'SMS status',
        'Sending': 'Sending',
        'Sent to telecommunication': 'Sent to telecommunication',
        'Document number': 'Document number',
        'Account': 'Account',
        'Receiver': 'Receiver',
        'Entry date': 'Entry date',
        'Due date': 'Due date',
        'Cost type': 'Cost type',
        'Amount': 'Amount',
        'Paid': 'Paid',
        'Payment in progress': 'Payment in progress',
        'revoked': 'revoked',
        'Buying Equipment': 'Buying Equipment',
        'Buying goods': 'Buying goods',
        'Transportation cost': 'Transportation cost',
        'Forwarding(transportation) cost': 'Forwarding(transportation) cost',
        'Water, electricity, telephone bills': 'Water, electricity, telephone bills',
        'Salary cost': 'Salary cost',
        'Payable documents': 'Payable documents',
        'Renting cost': 'Renting cost',
        'Fund/?': 'Fund/?',
        'Other cots': 'Other cots',

        'Payer': 'Payer',
        'Description': 'Description',
        'Bank acceptance type': 'Bank acceptance type',
        'Payment status': 'Payment status',
        'Receive from customer': 'Receive from customer',
        'Service and product order': 'Service and product order',
        'Beautician bank acceptance for rent': 'Beautician bank acceptance for rent',
        'Other  bank acceptance(recived) documents': 'Other  bank acceptance(recived) documents',
        'Account number': 'Account number',
        'Sheba number': 'Sheba number',
        'Debtor': 'Debtor',
        'Creditor': 'Creditor',
        'Account balance': 'Account balance',
        'Agent bank': 'Agent bank',
        'Refresh (update information)': 'Refresh (update information)',
        'Income trend': 'Income trend',
        'Update': 'Update',
        'cost and income Total report': 'cost and income Total report',

        'Income from reserving services': 'Income from reserving services',
        'Income from selling products': 'Income from selling products',
        'Total income': 'Total income',
        'Total cost': 'Total cost',
        'profit': 'profit',
        'Total Income from reserving services': 'Total Income from reserving services',
        'Total Income from selling products': 'Total Income from selling products',
        'Total costs': 'Total costs',
        'costs': 'costs',
        'QTY': 'QTY',
        'Role managements': 'Role managements',
        'User role': 'User role',
        'User managements': 'User managements',
        'Role accesses': 'Role accesses',
        'Choosing Date and services': 'Choosing Date and services',
        'Choosing beautician and time': 'Choosing beautician and time',
        'View receipt': 'View receipt',
        'Final approval': 'Final approval',
        'Order': ' Order',
        'Visit date': 'Visit date',
        'Visit time': 'Visit time',
        'End time': 'End time',
        'services': 'services',
        'beautician': 'beautician',
        'Total price': 'Total price',
        'survey': 'survey',
        'Print receipt': 'Print receipt',
        'print': 'print',
        'Discount or credit code entry': 'Discount or credit code entry',
        'Payable amount': 'Payable amount ',
        'pay': 'pay',
        'pays': 'Pays',
        'Cancel order': 'Cancel order',
        'Arrange next visit': 'Arrange next visit',
        'Description and notes': 'Description and notes',
        'Status description': 'Status description',
        'Attachment/note': 'Attachment/note',
        'Reserved times': 'Reserved times',
        'Initial reservation and choosing time': 'Initial reservation and choosing time',
        'Instant reservation': 'Instant reservation',
        'Choose time': 'Choose time',
        'from': 'from',
        'Customer reservations and ?': 'Customer reservations and ?',
        'Notes and attachments': 'Notes and attachments',
        'Add note/attachment': 'Add note/attachment',
        'Total customer orders': 'Total customer orders',
        'Total customer payments': 'Total customer payments',
        'Residual payable amount': 'Residual payable amount',
        'Event managements': 'Event managements',
        'Attributes': 'Attributes',
        'Way of introduction': 'Way of introduction',
        'Introducer': 'Introducer',
        'Advertised site': 'Advertised site',
        'Advertised page': 'Advertised page',
        'Field of study': 'Field of study',
        'gender': 'gender',
        'Field of work': 'Field of work',
        'Date of birth': 'Date of birth',
        'profession': 'profession',
        'age': 'age',
        'Done and update information ': 'Done and update information',
        'toman': '$',
        'Number of visits': 'Number of visits',
        'Booking services': 'Booking services',
        'Sell Products': 'Sell Products',
        'Best-selling services': 'Best-selling services',
        'Reservations and Tracking': 'Reservations and Tracking',
        'Record reminder': 'Record reminder',
        'reminder': ' reminder',
        'Send': 'Send',
        'Close': 'Close',
        'Best-selling products': 'Best-selling products',
        'Personnel Management': 'Personnel Management',
        'Best': 'Best',
        'Calendar': 'Calendar ',
        'Ready to operate': 'Ready to operate',
        'No message': 'No message',
        'Show all': 'Show all',
        'Exit': 'Exit',
        'Phone call': 'Phone call',
        'Ordering goods and services': 'Ordering goods and services',
        'phone/mobail': 'phone/mobail',
        'New': 'New',
        'Submit request': 'Submit request',
        'any things': 'any things',
        'amount': 'amount ',
        'type': 'type',
        'Public': 'Public',
        'target': 'target',
        'Type of service': 'Type of service',
        'product type': 'product type',
        'Gift': 'Gift',
        'Excel Output List': 'Excel Output List',
        'Excel Output Service List': 'Excel Output Service List',
        'Excel Output Products List': 'Excel Output Products List',
        'Excel Output Personel List': 'Excel Output Personel List',
        'Excel Output Orders List': 'Excel Output Orders List',
        'Excel Output Account List': 'Excel Output Account List',
        'start time': 'start time',
        'End Time': 'End Time',
        'min': 'min',
        'Add categories': 'Add categories',
        'Return to the list': 'Return to the list',
        'receipt': 'Receipt',
        'Unknown': 'Unknown',
        'Service Name': 'Service Name',
        'Survey': 'Survey',
        'Product Name': 'Product Name',
        'time': 'time',
        'List of sent sms': 'List of sent sms',
        'Submitted text': 'Submitted text',
        'Include these tags': 'Include these tags',
        'Do not Include these tags': 'Include these tags',
        'User': 'User',
        'Update service': 'Update service',
        'Canceled': 'Canceled',
        'and time': 'and time',
        'Choose': 'Choose',
        's': 's',
        'Username': 'Username',
        'Password': 'Password',
        'Login': 'Login',
        'Payment approved': 'Payment approved',
        'Order done': 'Order done',
        'Good': 'Good',
        'Apply a discount code': 'Apply a discount code',
        'Total Amount': 'Total Amount',
        'Discount Percentage as': 'Discount Percentage as',
        'Subtracted from total amount': 'Subtracted from total amount',
        'Credit discount with title': 'Credit discount with title',
        'Payment receipt successfully deducted from customer credit': ' Payment receipt successfully deducted from customer credit',
        'Remaining to pay': 'Remaining to pay',
        'Extra customer credit': 'Extra customer credit',
        'Set next reminder': 'Set next reminder',
        'Final confirmation of service (receiving points)': 'Final confirmation of service (receiving points)',
        'Balance payable': 'Balance payable',
        'Total payments for receipts': 'Total payments for receipts',
        'The total amount reached': 'The total amount reached',
        'The remaining amount is due for payment': 'The remaining amount is due for payment',
        'Confirmation of payment of outstanding balance': 'Confirmation of payment of outstanding balance',
        'Download': 'Download',
        'Order number': 'Order number',
        'Start': 'Start',
        'End': 'End',
        'Description of service': 'Description of service',
        'Back was shown': 'Back was shown',
        'Next for': 'Next for',
        'reservation date': 'reservation date',
        'Between time': 'Between time',
        'Initial registration and appointment': 'Initial registration and appointment',
        'Hair': 'Hair',
        'Nails': 'Nails',
        'Nail services': 'Nail services',
        'Rosary times': 'Rosary times',
        'Reservation plan': 'Reservation plan',
        'Reprogramming': 'Reprogramming',
        'Click': 'Click',
        'Button to select the beginning time of booking and service first': 'Button to select the beginning time of booking and service first',
        'Click on the button to select the next service you want': 'Click on the button to select the next service you want',
        'Contacts': 'Contacts',
        'National Code': 'National Code',
        'booking': 'booking',
        'Manage payments/credit enhancement': 'Manage payments/credit enhancement',
        'other information': 'other information',
        'Attribute': 'Attribute',
        'Referral site': 'Referral site',
        'Field': 'Field',
        'Height': 'Height',
        'Weight': 'Weight',
        'disease background': 'disease background',
        'Heart': 'Heart',
        'Breathing': 'Breathing',
        'Liver': 'Liver',
        'Kidney': 'Kidney',
        'Diabetes': 'Diabetes',
        'Seizure': 'Seizure',
        'infectious disease': 'infectious disease',
        'Herpes simplex history': 'Herpes simplex history',
        'Tumor': 'Tumor',
        'Asthma': 'Asthma',
        'Thyroid': 'Thyroid',
        'Disorder': 'Disorder',
        'Hermione': 'Hermione',
        'other': 'other',
        'History of medication use': 'History of medication use',
        'Aspirin': 'Aspirin',
        'Anticonvulsant': 'Anticonvulsant',
        'Arfarin': 'Arfarin',
        'Heparin': 'Heparin',
        'Minoxide': 'Minoxide',
        'Hormone Drug': 'Hormone Drug',
        'Rakutan': 'Rakutan',
        'DiaphPeeling Creamragm': 'DiaphPeeling Creamragm',
        'Tanned in the last two months': 'Tanned in the last two months',
        'Yes': 'Yes',
        'No': 'No',
        'A history of any allergy, seasonality, medication, food?': 'A history of any allergy, seasonality, medication, food?',
        'Surgical history': 'Surgical history',
        'Type of surgery': 'Type of surgery',
        'Surgery': 'Surgery',
        'Get pregnant right now': 'Get pregnant right now',
        'Lactation': 'Lactation',
        'History of Botox injection': 'History of Botox injection',
        'History of gel injection': 'History of gel injection',
        'Laser history': 'Laser history',
        'Registering and updating information': 'Registering and updating information',
        'Add feature': 'Add feature',
        'Booking receipt registration': 'Booking receipt registration',
        'The amount of': 'The amount of',
        'Time to attend': 'Time to attend',
        'Cost': 'Cost',
        'Receipt Request': 'Receipt Request',
        'Points / Degree of importance': 'Points / Degree of importance',
        'the attachment': 'the attachment',
        'Caller phone': 'Caller phone',
        'editing information': 'editing information',
        'Continues': 'Continues',
        'A reminder of the date of attendance': 'A reminder of the date of attendance',
        'Support team': 'Support team',
        'An email for you': 'An email for you',
        'Registered as': 'Registered as',
        'Overall Poll': 'Overall Poll',
        'Submit comment': 'Submit comment',
        'Sample': 'Sample',
        'Serial': 'Serial',
        'Opinion': 'Opinion',
        'About Me': 'About Me',
        'Location': 'Location',
        'Favorites': 'Favorites',
        'Add interest':'Add interest',
        'Events':'Events',
        'Orders':'Orders',
        'Remind date of attendance':'Remind date of attendance',
        'Facial Services':'Facial Services',
        'Clearing':'Clearing',
        'Cleansing mask':'Cleansing mask',
        'Raspberry and honey mask':'Raspberry and honey mask',
        'until the':'until the',
        'It was Tibet':'It was Tibet',
        'Item saved successfully':'Item saved successfully',
        'Information updated successfully':'Information updated successfully',
        'Unable to update information':'Unable to update information',
        'The service is not selected correctly':'The service is not selected correctly',
        'Day selection and service completed successfully':'Day selection and service completed successfully',
        'There is no blank expert on the selected date':'There is no blank expert on the selected date',
        'Selected product inventory is running out': 'Selected product inventory is running out',
        'In the process of payment':'In the process of payment',
        'Your access to this section is restricted':'Your access to this section is restricted',
        'Are you sure you want to delete the item?':'Are you sure you want to delete the item?',
        'Cannot delete item':'Cannot delete item',
        'Add product category':'Add product category',
        'Return to product list':'Return to product list',
        'Return to profile':'Return to profile',
        'Increase credit (payment)':'Increase credit (payment)',
        'tags':'tags',
        'Unable to load item':'Unable to load item',
        'Are you sure you want to delete the reminder?':'Are you sure you want to delete the reminder?',
        'Unable to load categories':'Unable to load categories',
        'Successfully registered':'Successfully registered',
        'List all gifts':'List all gifts',
        'Buy':'Buy',
        'Buy gifts':'Buy gifts',
        'A list of gifts for you':'A list of gifts for you',
        'Purchase done':'Purchase done',
        'Are you sure you want to cancel the order?':'Are you sure you want to cancel the order?',
        'Cancellation successful':'Cancellation successful',
        'Cannot cancel item':'Cannot cancel item',
        'Unable to load data':'Unable to load data',
        'Service updated successfully':'Service updated successfully',
        'Unable to update services':'Unable to update services',
        'Request information is not available':'Request information is not available',
        'Discount code applied successfully':'Discount code applied successfully',
        'The selected amount is greater than the remaining factor of the invoice':'The selected amount is greater than the remaining factor of the invoice',
        'Payment confirmed successfully':'Payment confirmed successfully',
        'Order canceled':'Order canceled',
        'Are you sure you have a final order confirmation?':'Are you sure you have a final order confirmation?',
        'The service was successfully approved':'The service was successfully approved',
        'Next reminder set successfully':'Next reminder set successfully',
        'No information available':'No information available',
        'The length of service is longer than your chosen time':'The length of service is longer than your chosen time',
        'Selected times are already filled':'Selected times are already filled',
        'You have time to complete the order':'You have time to complete the order',
        'There is a time lag between your choices':'There is a time lag between your choices',
        'Excel Output Report':'Excel Output Report',
        'Total revenue from booking services':'Total revenue from booking services',
        'Total proceeds from product sales':'Total proceeds from product sales',
        'Income from products':'Income from products',
        'cots':'cots',
        'Sum of payments':'Sum of payments',
        'Personnel Income':'Personnel Income',
        'Personnel':'Personnel',
        'The whole function':'The whole function',
        'Sum of functions':'Sum of functions',
        'etc':'etc'



    }
}

// VueI18n instance
export default new VueI18n({
    locale: 'fa',
    messages
})